export default __webpack_public_path__ + "static/media/formWorkflow.311c9400.png";